import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import api from './api/apiList'
import echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/base.css';
import './assets/style/animate.css';
import './utils/common/commonHelper';

Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$echarts = echarts;
Vue.prototype.$eventBus = new Vue();
Vue.config.productionTip = false;

import Collapse from '../src/components/common/communal/Collapse.vue'
import Tag from '../src/components/common/communal/Tag.vue'
import TagButton from '../src/components/common/communal/TagButton.vue'
import Table from '../src/components/common/communal/Table.vue'
import Pagination from '../src/components/common/communal/Pagination.vue'
import BaseDrawer from '../src/components/common/BaseDrawer.vue'
Vue.component('Collapse', Collapse);
Vue.component('Tag', Tag);
Vue.component('TagButton', TagButton);
Vue.component('Table', Table);
Vue.component('Pagination', Pagination);
Vue.component('BaseDrawer', BaseDrawer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');